"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import useUCConsent from "~/hooks/use-uc-consent";
import { useLanguage } from "~/translations/loader/use-language";

/**
 * KununuBox - Kununu rating widget for econ
 * Only shows Kununu widget if user has consented to Kununu cookies
 */
export default function KununuBoxEcon() {
  const $ = _c(15);
  const t = useLanguage();
  const {
    consentStatus
  } = useUCConsent("Kununu");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CustomImage alt="Kununu" height={48} src="images/icons/kununu_red.svg" width={48} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.jobad_exp_card1_title) {
    t1 = <div className="mb-6 flex items-center gap-x-4">{t0}<h3 className="font-bold text-4xl text-primary">{t.jobad_exp_card1_title}</h3></div>;
    $[1] = t.jobad_exp_card1_title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = t.econ_kununu_text || "";
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="space-y-2 text-foreground [&_p]:mb-2" dangerouslySetInnerHTML={{
      __html: t2
    }} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== consentStatus || $[6] !== t.jobad_exp_kununu_linkTitle) {
    t4 = consentStatus && <CustomLink aria-label={t.jobad_exp_kununu_linkTitle} blank={true} href="https://www.kununu.com/de/eon-inhouse-consulting" title={t.jobad_exp_kununu_linkTitle}><CustomImage alt="Kununu Rating" className="w-auto object-contain" height={100} src="https://widgets.kununu.com/widget_icon_score_review_count_big/profiles/26d360e0-d4cc-414c-8943-0a3e02f2a893" unoptimized={true} width={170} /></CustomLink>;
    $[5] = consentStatus;
    $[6] = t.jobad_exp_kununu_linkTitle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CustomImage alt="Top Company" className="w-auto object-contain" height={160} src="images/jobad/econ/top_company_2026.webp" width={120} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <div className="mt-6 flex gap-x-4">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t6) {
    t7 = <div className="mt-10 bg-card p-10">{t1}{t3}{t6}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}